import { InjectionToken } from "@angular/core";
import { Resolve } from "@angular/router";
import { IWidget } from "../../../../models/application/i-widget";

export const widgetResolverInjectionToken: InjectionToken<Resolve<IWidget>> = new InjectionToken<Resolve<IWidget>>("digital-signage-developer-dashboard.WidgetResolver");
